import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import { fieldsProps } from './schema';
import Select from '../../fields/SelectBox';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRoles } from '../../layouts/PageBase/actions';
import { useDropdown } from '../../../utils/hooks';

export default function ChangeUserRoleForm({
  handleSubmit = () => {},
  initialValues = {},
  isLoading = false,
}) {
  const dispatch = useDispatch();
  const { dataRoles } = useSelector((state) => state.pageBase);
  const { message, loading } = useSelector((state) => state.user);
  const { values, isValid, handleBlur, handleChange } = useDropdown(
    {
      roleId: { error: '', touched: false, value: '' },
    },
    initialValues
  );
  const { roleId } = values;

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({
      ...initialValues,
      regional: initialValues.regionalId,
      roleId: roleId?.value,
    });
  };

  useEffect(() => {
    dispatch(fetchRoles());
  }, []);

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      {message ? <p className={styles.error}>{message}</p> : null}
      <div className={styles.dropdown}>
        <Select
          data={dataRoles}
          eventName="roleId"
          hideLabel
          meta={{ ...roleId }}
          name="roleId"
          onBlur={(e) => handleBlur(e, 'roleId')}
          onChangeSelect={(value) => handleChange(value, 'roleId')}
          placeholder={fieldsProps.role.placeholder}
          valueForm={roleId?.value}
        />
      </div>
      <Button
        disabled={!isValid || loading}
        eventName="ChangeUserRoleForm"
        type="submit"
      >
        {isLoading ? 'Menyimpan...' : 'Simpan'}
      </Button>
    </form>
  );
}

ChangeUserRoleForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  isLoading: PropTypes.bool,
};
